import { CoreIcon } from '../core-icon';
import dateSVG from '../../assets/icons/date.svg';
import type { IconProps } from '../core-icon';

export const DateIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={dateSVG} {...props} />;
};
